// The store's handle on persistence; tests swap in an in-memory storage.
import { browserStorage, type StorageLike } from '../persist';

let storage: StorageLike | null | undefined;

export function configureStorage(next: StorageLike | null): void {
  storage = next;
}

export function currentStorage(): StorageLike | null {
  storage ??= browserStorage();
  return storage;
}

/** A Map-backed StorageLike for tests and private browsing. */
export function memoryStorage(): StorageLike {
  const data = new Map<string, string>();
  return {
    getItem: (key) => data.get(key) ?? null,
    setItem: (key, value) => {
      data.set(key, value);
    },
    removeItem: (key) => {
      data.delete(key);
    },
  };
}
